
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { FeatureName } from './feature';
import { superCustomersReducer } from './reducer';
import { SuperCustomersStoreEffects } from './effects';


@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature(FeatureName, superCustomersReducer),
		EffectsModule.forFeature([SuperCustomersStoreEffects])
	]
})

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class SuperCustomersStoreModule { }
